import React from 'react';
import Button from './Button';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import WalletAvater from "../../../../../../assets/images/user_app/user_wallet_icon.svg";
import DownArrow from "../../../../../../assets/images/user_app/down_arrow_connect_button.svg";

export const CustomConnectButton = (props) => {
    return (
        <ConnectButton.Custom>
            {({
                account,
                chain,
                openAccountModal,
                openChainModal,
                openConnectModal,
                authenticationStatus,
                mounted,
            }) => {
                // Note: If your app doesn't use authentication, you
                // can remove all 'authenticationStatus' checks
                const ready = mounted && authenticationStatus !== 'loading';
                const connected =
                    ready &&
                    account &&
                    chain &&
                    (!authenticationStatus ||
                        authenticationStatus === 'authenticated');

                return (
                    <div
                        {...(!ready && {
                            'aria-hidden': true,
                            'style': {
                                opacity: 0,
                                pointerEvents: 'none',
                                userSelect: 'none',
                            },
                        })}
                    >
                        {(() => {
                            if (!connected) {
                                {/* The Primary Button */ }
                                return (
                                    <Button onClick={openConnectModal} type="button" color="black-rainbow" fullWidth={true} size={props.size || "large"}>
                                        Connect Wallet
                                    </Button>
                                );
                            }

                            {/* When you are on the wrong network */ }
                            {/* We don't care what network you are on. */ }
                            {/* if (chain.unsupported) {
                                return (
                                    <button onClick={openChainModal} type="button">
                                        Wrong network
                                    </button>
                                );
                            } */}

                            {/* Connected and on the correct network */ }
                            return (
                                <div style={{ display: 'flex', gap: 12 }}>
                                    {/* Don't show any chain info. */}
                                    {/* <button
                                        onClick={openChainModal}
                                        style={{ display: 'flex', alignItems: 'center' }}
                                        type="button"
                                    >
                                        {chain.hasIcon && (
                                            <div
                                                style={{
                                                    background: chain.iconBackground,
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: 999,
                                                    overflow: 'hidden',
                                                    marginRight: 4,
                                                }}
                                            >
                                                {chain.iconUrl && (
                                                    <img
                                                        alt={chain.name ?? 'Chain icon'}
                                                        src={chain.iconUrl}
                                                        style={{ width: 12, height: 12 }}
                                                    />
                                                )}
                                            </div>
                                        )}
                                        {chain.name}
                                    </button> */}

                                    <Button onClick={openAccountModal} type="button" color="black-rainbow" fullWidth={true} size={props.size || "large"}>
                                        <div className="connect-button-content-container">
                                            <img src={WalletAvater} alt="Wallet Avatar" width={22} height={22} />
                                            {account.displayName}
                                            <img src={DownArrow} alt="Down Arrow" />
                                        </div>
                                        {/* We do NOT show balance */}
                                        {/* {account.displayBalance
                                            ? ` (${account.displayBalance})`
                                            : ''} */}
                                    </Button>
                                </div>
                            );
                        })()}
                    </div>
                );
            }}
        </ConnectButton.Custom>
    );
};

